import styled from 'styled-components';
import { rgba } from 'polished';

export const FilterContainer = styled.div`
  position: relative;
`;

export const FilterMenuContainer = styled.div`
  position: absolute;
  right: 0;
  z-index: 6;
  top: calc(100% + 4px);
  transition: 0.2s;
  width: 300px;
  border-radius: 4px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.background.default};
  box-shadow: ${({ theme }) =>
    `0px 0px 4px 0px ${rgba(theme.colors.common.contrast, 0.08)}, 0px 8px 24px 0px ${rgba(
      theme.colors.common.contrast,
      0.2
    )}`};
  opacity: 0;
  &.enter-active {
    opacity: 1;
  }
  &.enter-done {
    opacity: 1;
  }
  &.exit-active {
    opacity: 0;
  }
  &.exit-done {
    opacity: 0;
  }
  & > div {
    display: flex;
    flex-direction: column;
    & > p {
      margin-bottom: 10px;
      font-size: 14px;
    }
    & > div {
      width: 100%;
    }
  }
`;
